import { TPAComponentProps } from '../../types';

export enum CalendarCellAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}

export enum CalendarCellTimes {
  pastDate = 'pastDate',
  today = 'today',
  futureDate = 'futureDate',
}

export interface CalendarCellProps extends TPAComponentProps {
  title: string;
  children?: any;
  stretchable?: boolean;
  current?: boolean;
  alignment?: CalendarCellAlignment;
  timeType?: CalendarCellTimes;
}

export interface CalendarCellDefaultProps {
  stretchable: boolean;
  current: boolean;
  alignment: CalendarCellAlignment;
  timeType: CalendarCellTimes;
}

export enum CalendarCellDataKeys {
  Stertchable = 'data-stretchable',
  TimeType = 'data-time-type',
  Current = 'data-current',
  Alignment = 'data-alignment',
}
